
(function () {
  'use strict';

  var LoadMorePagination = class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-load-more-button]');
      this.counter = this.querySelector('[data-load-more-counter]');
      this.progressBar = this.querySelector('[data-load-more-progress]');
      this.loading = false;

      if (this.button) {
        this.button.addEventListener('click', this._onButtonClick.bind(this));
      }

      if (this.getAttribute('data-mode') === 'infinite' && 'IntersectionObserver' in window) {
        this._setupInfiniteScroll();
      }
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
      if (this.abortController) {
        this.abortController.abort();
      }
    }

    get productListInner() {
      var main = this.closest('#facet-main') || document;
      return main.querySelector('.product-list__inner');
    }

    /* ---------- Events ---------- */

    _onButtonClick(event) {
      event.preventDefault();
      this.loadNext();
    }

    _setupInfiniteScroll() {
      this.observer = new IntersectionObserver(
        function (entries) {
          if (entries[0].isIntersecting) {
            this.loadNext();
          }
        }.bind(this),
        { rootMargin: '600px 0px' }
      );
      this.observer.observe(this);
    }

    /* ---------- Kernlogik ---------- */

    async loadNext() {
      if (this.loading || !this.button || this.button.hidden) {
        return;
      }
      this.loading = true;
      this._setButtonLoading(true);

      try {
        var nextUrl = new URL(this.button.href, window.location.origin);
        var fetchUrl = new URL(nextUrl);
        fetchUrl.searchParams.set('section_id', this.getAttribute('data-section-id'));

        this.abortController = new AbortController();
        var response = await fetch(fetchUrl.toString(), { signal: this.abortController.signal });
        if (!response.ok) {
          throw new Error('Load more failed: ' + response.status);
        }
        var html = await response.text();
        var doc = new DOMParser().parseFromString(html, 'text/html');

        this._appendProducts(doc);
        this._syncStateFrom(doc);

        this._replaceListUrl();

        document.documentElement.dispatchEvent(
          new CustomEvent('loadmore:page-loaded', {
            bubbles: true,
            detail: { page: parseInt(this.getAttribute('data-page'), 10) }
          })
        );
      } catch (e) {
        if (e.name !== 'AbortError') {
          /* Netzwerkfehler: Fallback auf normale Link-Navigation */
          console.error(e);
          if (this.button) {
            window.location.href = this.button.href;
          }
        }
      } finally {
        this.loading = false;
        this._setButtonLoading(false);
      }
    }

    _appendProducts(doc) {
      var newInner = doc.querySelector('.product-list__inner');
      var target = this.productListInner;
      if (!newInner || !target) {
        return;
      }

      var fragment = document.createDocumentFragment();
      Array.from(newInner.children).forEach(function (item) {
        /* Stagger-Animation gilt nur für den Initial-Load */
        item.removeAttribute('reveal');
        /* Eager/fetchpriority-Hints der Folgeseite neutralisieren –
           die Karten sind beim Anhängen bereits im/nahe dem Viewport-Ende */
        item.querySelectorAll('img[loading="eager"]').forEach(function (img) {
          img.loading = 'lazy';
          img.removeAttribute('fetchpriority');
        });
        fragment.appendChild(item);
      });
      target.appendChild(fragment);
    }

    _syncStateFrom(doc) {
      var fresh = doc.querySelector('load-more-pagination');

      if (!fresh) {
        /* Letzte Seite erreicht */
        this._finish();
        return;
      }

      this.setAttribute('data-page', fresh.getAttribute('data-page'));

      var freshCounter = fresh.querySelector('[data-load-more-counter]');
      if (this.counter && freshCounter) {
        this.counter.textContent = freshCounter.textContent;
      }

      var freshProgress = fresh.querySelector('[data-load-more-progress]');
      if (this.progressBar && freshProgress) {
        this.progressBar.style.width = freshProgress.style.width;
        var progressWrapper = this.progressBar.closest('[role="progressbar"]');
        var freshWrapper = freshProgress.closest('[role="progressbar"]');
        if (progressWrapper && freshWrapper) {
          progressWrapper.setAttribute('aria-valuenow', freshWrapper.getAttribute('aria-valuenow'));
        }
      }

      var freshButton = fresh.querySelector('[data-load-more-button]');
      if (freshButton) {
        this.button.href = freshButton.href;
      } else {
        this._finish();
      }
    }

    _finish() {
      if (this.button) {
        this.button.hidden = true;
      }
      if (this.observer) {
        this.observer.disconnect();
      }
      if (this.progressBar) {
        this.progressBar.style.width = '100%';
      }
    }

    _setButtonLoading(isLoading) {
      if (!this.button) {
        return;
      }
      this.button.classList.toggle('load-more__button--loading', isLoading);
      this.button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      var label = this.button.querySelector('.load-more__label');
      var loader = this.button.querySelector('.load-more__loader');
      if (label && loader) {
        label.hidden = isLoading;
        loader.hidden = !isLoading;
      }
    }

    _listUrl() {
      var url = new URL(window.location.href);
      url.searchParams.delete('page');
      return url.pathname + url.search + url.hash;
    }

    _replaceListUrl() {
      var next = this._listUrl();
      if (next !== window.location.pathname + window.location.search + window.location.hash) {
        history.replaceState(history.state, '', next);
      }
    }
  };

  if (!window.customElements.get('load-more-pagination')) {
    window.customElements.define('load-more-pagination', LoadMorePagination);
  }
})();
